(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flamora-home-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('flamora-home-benefits')) {
    customElements.define('flamora-home-benefits', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.triggers = new Map();
        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;
          const trigger = event.target.closest('[data-benefit-dialog]');
          if (trigger && this.contains(trigger)) {
            const dialog = this.querySelector('[id="' + trigger.dataset.benefitDialog + '"]');
            if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
            this.triggers.set(dialog, trigger);
            dialog.showModal();
            dialog.querySelector('.fl-benefit-dialog__done').focus({ preventScroll: true });
            return;
          }
          const close = event.target.closest('[data-benefit-close]');
          if (close) close.closest('dialog')?.close();
        });
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('keydown', event => {
            if (event.key !== 'Tab') return;
            const controls = Array.from(dialog.querySelectorAll('button:not(:disabled), a[href]')).filter(element => element.getClientRects().length);
            const first = controls[0];
            const last = controls[controls.length - 1];
            if ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
              event.preventDefault();
              (event.shiftKey ? last : first)?.focus();
            }
          });
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          });
          dialog.addEventListener('close', () => {
            const trigger = this.triggers.get(dialog);
            this.triggers.delete(dialog);
            if (trigger?.isConnected) trigger.focus({ preventScroll: true });
          });
        });
      }
      disconnectedCallback() {
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        this.triggers?.clear();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('flamora-background-video')){
  customElements.define('flamora-background-video',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.video=this.querySelector('video');this.button=this.querySelector('button');
      if(!this.video||!this.button)return;
      this.controller=new AbortController();const options={signal:this.controller.signal};
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.userPaused=this.motion.matches;
      this.video.muted=true;this.video.controls=false;this.video.setAttribute('playsinline','');
      this.sync=()=>{this.classList.toggle('is-paused',this.video.paused);this.button.setAttribute('aria-label',this.video.paused?this.dataset.play:this.dataset.pause)};
      this.refresh=()=>{if(!this.visible||this.userPaused||document.hidden){this.video.pause();return}this.video.play().catch(()=>{this.button.hidden=false;this.sync()})};
      this.video.addEventListener('playing',()=>{this.classList.add('is-ready');this.button.hidden=false;this.sync()},options);
      this.video.addEventListener('pause',this.sync,options);
      this.button.addEventListener('click',()=>{this.userPaused=!this.video.paused;this.refresh()},options);
      document.addEventListener('visibilitychange',this.refresh,options);
      this.motionChanged=e=>{this.userPaused=e.matches;this.refresh()};
      this.motion.addEventListener('change',this.motionChanged);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.refresh()},{threshold:0.1});
      this.observer.observe(this);
    }
    disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();this.motion?.removeEventListener('change',this.motionChanged);this.video?.pause();this.controller=null}
  })
}

  } catch(e) { console.error(e); }
})();
})();
